module.exports = __webpack_public_path__ + "media/assets/images/blog/Depositphotos_469824058_L-small-dc0ae0463ec0db5fd8678672fee5a179.jpg";